export default __webpack_public_path__ + "static/media/back.ebc55ad9.svg";